import { render, staticRenderFns } from "./DadosEstacionamento.vue?vue&type=template&id=0a54ddf4"
import script from "./DadosEstacionamento.vue?vue&type=script&lang=js"
export * from "./DadosEstacionamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports